import { render, staticRenderFns } from "./mainLayout.vue?vue&type=template&id=4c0e8e9f&scoped=true&"
import script from "./mainLayout.vue?vue&type=script&lang=js&"
export * from "./mainLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0e8e9f",
  null
  
)

export default component.exports